"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPhoneNumber = void 0;
const COUNTRY_CODE = '55';
const countryCodeRegex = new RegExp(`^\\+${COUNTRY_CODE}\\s?`, 'g');
/**
 * Extrai um número de telefone de uma string fornecida, removendo quaisquer caracteres não numéricos
 * e o código do país.
 *
 * @param {string} phoneNumber - O número de telefone a ser extraído.
 * @return {string} O número de telefone extraído com os caracteres não numéricos e código do país removidos.
 */
const extractPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
        return '';
    }
    const matchCountryCode = phoneNumber.match(countryCodeRegex);
    const phoneStartsWithCountryCode = phoneNumber.startsWith(COUNTRY_CODE);
    if (!matchCountryCode && !phoneStartsWithCountryCode) {
        return phoneNumber.replace(/\s?\D/g, '');
    }
    return phoneNumber.replace(countryCodeRegex, '').replace(/\D/g, '');
};
exports.extractPhoneNumber = extractPhoneNumber;
